/**
 * Classe responsável pelas Informações da rota
 * @author: Adalto Junior adaltojunior@sagaranatech.com.br
 * DATE: 07/01/2013
 * TIME: 10:58
 *
 */


Greenmile.RouteDetail = Greenmile.RouteDetail || {};

Greenmile.RouteDetail.InfoRoute = function (map, routeId) {

    const sourceScreen = Monet.Session.RouteDetail.screensList[routeId];

    this.removeLayerById = function (layerId) {
      map.eachLayer(function (layer) {
          const kind = layer.kind;

          if(kind === "EQUIPMENT") {
            const sourceId = layer?.coordinates?.positionSource?.source;

            if(sourceId === layerId) {
              map.removeLayer(layer);
            }
          }
          

          if(kind === "ACTUAL_ROUTE") {
            const sourceId = layer.options?.positionSource?.id;

            if(sourceId === layerId) {
              map.removeLayer(layer);
            }
          }

          if(kind === "ARROW") {
            const sourceId = layer?.coordinate?.positionSource?.source;

            if(sourceId === layerId) {
              map.removeLayer(layer);
            }
          }
      });
  };

    this.removeActualRoute = function () {
      map.eachLayer(function (layer) {
          const kind = layer.kind;

          if (["ACTUAL_ROUTE", "ARROW", "SECONDARY_ROUTE", "SECONDARY_EQUIPMENT"].indexOf(kind) > -1) {
              map.removeLayer(layer);
          }
      });
  };

    this.blockCanMakeCoordinates = function () {
        sourceScreen.canMakeCoordinates = false;
        sourceScreen.canShowLayerCoordinates = false;
    };

    this.enableCanMakeCoordinates = function () {
        sourceScreen.canMakeCoordinates = true;
        sourceScreen.canShowLayerCoordinates = true;
    };

    this.getCoordinatesAndDrawOnMap = function (callbackAfterGetCoordinates, loadEvents) {
      const screenList = Monet.Session.RouteDetail.screensList[routeId];
      const principalEquipment = screenList.equipment;
      const route = screenList.model;
      const routeEquipmentAssignments = route.equipmentAssignments;
      const routeInMultiRouteCache =
        Greenmile.RouteDetail.MultiRouteCache?.routes[routeId];
        
      let equipmentsList = [];
      if (routeInMultiRouteCache?.equipmentsList.length) {
        equipmentsList = routeInMultiRouteCache.equipmentsList;
      } else if (routeEquipmentAssignments) {
        equipmentsList = routeEquipmentAssignments.map(function (equipment) {
          return equipment.equipment;
        });
      }

      if (principalEquipment?.idOfObject) {
        Monet.Session.RouteDetail.screensList[routeId].equipments =
          Monet.Session.RouteDetail.screensList[routeId].equipments || {};
        Monet.Session.RouteDetail.screensList[routeId].equipments[
          principalEquipment.idOfObject
        ] =
          Monet.Session.RouteDetail.screensList[routeId].equipments[
            principalEquipment.idOfObject
          ] || {};
      }

      const interval = App.Objects['RouteDetails_' + routeId].initDates();
      const controller = new Greenmile.RouteDetail.MultiRouteController();
      controller.generatePathForEquipmentsInInterval(
        route,
        equipmentsList,
        interval.beginDate,
        interval.endDate,
        callbackAfterGetCoordinates
      );

      if (loadEvents) {
        screenList.eventRoute.cleanMarkerEvent(() =>
          screenList.eventRoute.requestEventsAndAddOnMap()
        );
      }
    };

};
